import { currentUrl, parseUrl } from "Shared/url";
export const ACCOUNT_BOX_OPEN = "ACCOUNT_BOX_OPEN";
export const ACCOUNT_BOX_CLOSE = "ACCOUNT_BOX_CLOSE";
export const ACTION_REQUIRES_LOGIN = "ACTION_REQUIRES_LOGIN";
export const ACCOUNT_SWITCH_TAB = "ACCOUNT_SWITCH_TAB";
export const setAccountBoxOpen = (tab = "login", message, redirectToAfterLogin, enableAutofocus = true) => {
    return {
        type: ACCOUNT_BOX_OPEN,
        message: message,
        redirectToAfterLogin: redirectToAfterLogin,
        tab: tab,
        enableAutofocus: enableAutofocus,
    };
};
export const setLoginUrl = () => {
    window.location.href = "/login";
};
export const setAccountBoxClose = () => {
    return {
        type: ACCOUNT_BOX_CLOSE,
    };
};
export function openLoginBoxIfUrlSaysSo(store) {
    const queryParam = "login";
    const queryParamValue = "required";
    const returnUrlQueryParam = "ReturnUrl";
    const url = currentUrl();
    const returnUrl = returnUrlQueryParam in url.query
        ? parseUrl(url.query[returnUrlQueryParam])
        : null;
    if (url.query[queryParam] === queryParamValue &&
        !store.getState().currentUser.isLoggedIn) {
        store.dispatch(setAccountBoxOpen("login", "", returnUrl));
    }
}
export function openRegisterBoxIfUrlSaysSo(store) {
    const queryParam = "register";
    const url = currentUrl();
    if (queryParam in url.query &&
        !store.getState().currentUser.isLoggedIn) {
        store.dispatch(setAccountBoxOpen("register", "", undefined, false));
    }
}
